import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { HostListener, Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.modal/view.scss */
.newlife-alert-layer {
  position: fixed;
  inset: 0;
  z-index: 1000;
  font-family: SUIT, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.newlife-alert-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(15, 23, 42, 0.44);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  animation: newlife-alert-fade-in 0.14s ease-out both;
}

.newlife-alert-viewport {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  pointer-events: none;
}

.newlife-alert-panel {
  display: flex;
  width: min(100%, 23.5rem);
  max-height: calc(100dvh - 2rem);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: 0 18px 55px rgba(15, 23, 42, 0.2), 0 2px 8px rgba(15, 23, 42, 0.06);
  pointer-events: auto;
  animation: newlife-alert-pop-in 0.18s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.newlife-alert-body {
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem 1.5rem 1.25rem;
  overscroll-behavior: contain;
}

.newlife-alert-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.75rem;
}

.newlife-alert-symbol {
  display: inline-flex;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #fef3c7;
  color: #b45309;
}

.newlife-alert-layer[data-status=success] .newlife-alert-symbol {
  background: #ecfdf5;
  color: #059669;
}

.newlife-alert-layer[data-status=warning] .newlife-alert-symbol {
  background: #fffbeb;
  color: #d97706;
}

.newlife-alert-layer[data-status=error] .newlife-alert-symbol {
  background: #fff1f2;
  color: #e11d48;
}

.newlife-alert-symbol svg {
  width: 1.35rem;
  height: 1.35rem;
}

.newlife-alert-heading h2 {
  min-width: 0;
  margin: 0;
  color: #0f172a;
  font-size: 1.0625rem;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: -0.015em;
  overflow-wrap: anywhere;
}

.newlife-alert-message {
  margin: 0.875rem 0 0;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.65;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.newlife-alert-actions {
  display: grid;
  flex: 0 0 auto;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.625rem;
  padding: 0 1.5rem 1.5rem;
}

.newlife-alert-actions--single {
  grid-template-columns: minmax(0, 1fr);
}

.newlife-alert-button {
  display: inline-flex;
  min-height: 2.875rem;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0.75rem;
  padding: 0.7rem 1rem;
  font-size: 0.875rem;
  font-weight: 800;
  line-height: 1.25;
  transition: background-color 0.14s ease, box-shadow 0.14s ease, transform 0.14s ease;
}

.newlife-alert-button:active {
  transform: translateY(1px);
}

.newlife-alert-button--cancel {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
}

.newlife-alert-button--cancel:hover {
  background: #f8fafc;
}

.newlife-alert-button--action {
  background: #0f172a;
  color: #fff;
  box-shadow: 0 5px 14px rgba(15, 23, 42, 0.15);
}

.newlife-alert-button--action[data-tone=info],
.newlife-alert-button--action[data-tone=warning] {
  background: #facc15;
  color: #111827;
  box-shadow: 0 5px 14px rgba(250, 204, 21, 0.2);
}

.newlife-alert-button--action[data-tone=success] {
  background: #059669;
  box-shadow: 0 5px 14px rgba(5, 150, 105, 0.18);
}

.newlife-alert-button--action[data-tone=error] {
  background: #e11d48;
  box-shadow: 0 5px 14px rgba(225, 29, 72, 0.18);
}

.newlife-alert-button--action:hover {
  filter: brightness(0.97);
}

@media (max-width: 359px) {
  .newlife-alert-viewport {
    padding: 0.75rem;
  }
  .newlife-alert-body {
    padding: 1.25rem 1.25rem 1rem;
  }
  .newlife-alert-actions {
    padding: 0 1.25rem 1.25rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .newlife-alert-backdrop,
  .newlife-alert-panel {
    animation: none;
  }
  .newlife-alert-button {
    transition: none;
  }
}
@keyframes newlife-alert-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes newlife-alert-pop-in {
  from {
    opacity: 0;
    transform: translateY(0.375rem) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`],
})
export class PortalSeasonModalComponent implements OnInit {
    @Input() model: any = null;

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
    }

    public status(): string {
        const value = String(this.model?.opts?.status || 'info').toLowerCase();
        return ['success', 'warning', 'error', 'info'].includes(value)
            ? value
            : 'info';
    }

    public displayTitle(): string {
        const title = String(this.model?.opts?.title || '').trim();
        if (title) return title;

        if (this.status() === 'success') return '완료';
        if (this.status() === 'warning') return '확인 필요';
        if (this.status() === 'error') return '확인 필요';
        return '안내';
    }

    public isCancelable(): boolean {
        return Boolean(this.model?.opts?.cancel);
    }

    public cancelLabel(): string {
        const value = this.model?.opts?.cancel;
        return typeof value === 'string' && value.trim() ? value : '취소';
    }

    public actionTone(): string {
        const value = String(
            this.model?.opts?.actionBtn || this.model?.opts?.status || 'info'
        ).toLowerCase();
        return ['success', 'warning', 'error', 'info'].includes(value)
            ? value
            : 'info';
    }

    public async cancelModal() {
        if (!this.isCancelable()) return;
        if (typeof this.model.cancel === 'function') {
            await this.model.cancel();
            return;
        }
        await this.model.hide();
    }

    public async onBackdropClick() {
        await this.cancelModal();
    }

    @HostListener('document:keydown.escape')
    public async onEscape() {
        if (this.model?.isshow && this.isCancelable()) {
            await this.cancelModal();
        }
    }
}

export default PortalSeasonModalComponent;